import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/firestore";

if (!firebase.apps.length) {
  firebase.initializeApp({
    apiKey:
      process.env.FIREBASE_APY_KEY || "AIzaSyCDPcuL4qP8qAcg9tbHinHOA3onqKg6Xas",
    authDomain:
      process.env.FIREBASE_AUTH_DOMAIN || "real-time-chat-1a143.firebaseapp.com",
    projectId: process.env.FIREBASE_PROJECT_ID || "real-time-chat-1a143",
    storageBucket:
      process.env.FIREBASE_STORAGE_BUCKET || "real-time-chat-1a143.appspot.com",
    messagingSenderId: process.env.FIREBASE_MESSAGE_SENDER_ID || "340862776213",
    appId:
      process.env.FIREBASE_APP_ID || "1:340862776213:web:2741eda4837d6d5ef5fc9c",
    measurementId: process.env.FIREBASE_MEASUREMENT_ID || "G-4DLMDZ8NCJ",
  });
}

const firestore = firebase.firestore();

export { firebase, firestore };
